import axios from '@/axios'
import apiUrl from '@/axios/config'
const login = {
  // 登录
  async goLogin(params) {
    // return await axios.post('/uc/login', params, { des: '直客wap登录', sTime: new Date().getTime() })
    return await axios.post('/zk/login', params, { des: '直客wap登录', sTime: new Date().getTime() })  
  },
  // 获取用户信息
  async getUserInfo(params) {
    return await axios.post('/uc/user/userinfo/identityInfo', params, { des: '直客wap获取用户信息', sTime: new Date().getTime() })
  },
  // 腾讯验证码
  async getValidateAppId(params) {
    return await axios.post('/validateAppId', { params }, { des: '直客wap腾讯验证码', sTime: new Date().getTime() })
  },
  // 获取验证码
  async sendSms(params) {
    return await axios.post('/validateSendcode', params, { des: '直客wap获取验证码', sTime: new Date().getTime() })
  },
  // 忘记密码，获取验证码
  async sendSms2(params) {
    return await axios.post('/uc/sendcode', params, { des: '直客wap忘记密码，获取验证码', sTime: new Date().getTime() })
  },
  // 忘记密码，修改密码
  async rePwd(params) {
    return await axios.post('/uc/user/password/modify', params, { des: '直客wap忘记密码，修改密码', sTime: new Date().getTime() })
  },
  //找回密码API
  //验证姓名手机号
  async queryName(params) {
    return await axios.post('/queryNamePassword', params, { des: '直客wap验证姓名手机号', sTime: new Date().getTime() })
  },
  //找回密码发送验证码
  async pwdCode(params) {
    return await axios.post('/queryPasswordCode', params, { des: '直客wap找回密码发送验证码', sTime: new Date().getTime() })
  },
  //修改密码
  async submitNewPwd(params) {
    return await axios.post('/queryPassword', params, { des: '直客wap修改密码', sTime: new Date().getTime() })
  },
  /**************************************注册接口************************************* */
  //获取腾讯APPID  /validateAppId
  async getAppId(params = '') {
    return await axios.post('/validateAppId', params, { des: '直客wap获取腾讯APPID', sTime: new Date().getTime() })
  },
  //发送验证码接口
  async sendPhoneCode(params) {
    return await axios.post('/web/realaccount/sendcode', params, { des: '直客wap发送验证码接口', sTime: new Date().getTime() })
  },
  //真实账户注册接口
  async realRegister(params) {
    return await axios.post('/web/realaccount/register', params, { des: '直客wap真实账户注册接口', sTime: new Date().getTime() })
  },
  //模拟账户注册 
  async demoRegister(params) {
    return await axios.post('/web/simulatoraccount/register', params, { des: '直客wap模拟账户注册', sTime: new Date().getTime() })
  },
  //真实账户验证数据是否重复
  // async realUserData(params, option) {
  //   return await axios.post('/web/realaccount/validate', params, option)
  // },
  realUserData1(params) {
    return jQuery.ajax({
      async: false,
      type: 'post',
      data: params,
      xhrFields: { withCredentials: true },
      crossDomain: true,
      dataType: 'json',
      url: apiUrl.API_BASE_URL + '/web/realaccount/validate'
    })
  },
  //模拟账户验证数据是否重复
  // async demoUserData(params, option) {
  //   return await axios.post('/web/simulatoraccount/validate', params, option)
  // },
  //验证模拟账户手机号是否已被注册
  demoUserData2(params) {
    return jQuery.ajax({
      async: false,
      type: 'post',
      data: params,
      xhrFields: { withCredentials: true },
      crossDomain: true,
      dataType: 'json',
      url: apiUrl.API_BASE_URL + '/web/simulatoraccount/validate'
    })
  },
}

export default login


// WEBPACK FOOTER //
// ./src/api/login.js